module.exports = __webpack_public_path__ + "img/banner4-6.a086e85c.png";